import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/pagination'
import './swiperStyles.scss'

import { PlanBox } from 'Features/pricing/components/PlanBox/PlanBox'
import { useSelectPlan } from 'Features/pricing/hooks/useSelectPlan'
import { Plan } from 'Features/pricing/types/Plan'
import { isMobile } from 'react-device-detect'
import { PlansJson } from 'Types/Plan'
import { PLAN_TYPES } from 'Types/PlansTypes'
import { CurrenciesTypes } from 'Types/Currencies'
import { ProductTypes } from 'Types/ProductTypes'

type PlanSelectedProps = {
  numOfVisits: number
  plansDb: Array<Plan>
  plansJson: PlansJson
  productName: ProductTypes
  currency: CurrenciesTypes
  reactivation?: boolean
  billingCycleMonths?: number
}

export const PricingPlansMobile = ({
  numOfVisits,
  plansDb,
  currency,
  plansJson,
  productName,
  reactivation,
  billingCycleMonths,
}: PlanSelectedProps) => {
  const planSelected = useSelectPlan(plansDb, productName, currency)
  const plans = Object.entries(PLAN_TYPES)

  const renderPlanBox = () => {
    return plans.map(([key, value], index) => (
      <SwiperSlide key={key}>
        <PlanBox
          isFirst={index === 0}
          isLast={index === plans.length - 1}
          planName={value}
          plansJson={plansJson}
          productName={productName}
          plansDb={plansDb}
          numOfVisits={numOfVisits}
          currency={currency}
          disableButton={planSelected.isLoading}
          reactivation={reactivation}
          onClick={() => {
            planSelected.planSelected({
              type: value,
              numOfVisits: numOfVisits,
              billingCycleMonths: billingCycleMonths,
            })
          }}
        />
      </SwiperSlide>
    ))
  }

  return (
    <Swiper
      className="swiper"
      pagination={{ clickable: true }}
      modules={[Pagination]}
      allowSlideNext={isMobile}
      allowSlidePrev={isMobile}
    >
      {renderPlanBox()}
    </Swiper>
  )
}
